module.exports = __webpack_public_path__ + "static/media/SAM_0131.eba65d11.JPG";